// Plays an Agora video track into a container div.
import { useEffect, useRef } from "react";

export default function VideoPlayer({ track, className, style }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || !track) return;
    track.play(el);
    return () => {
      try {
        track.stop();
      } catch {
        /* already stopped */
      }
    };
  }, [track]);
  return <div ref={ref} className={className} style={style} />;
}
